import React from 'react';
import Table from "@amzn/awsui-components-react/polaris/table";
import TextFilter from "@amzn/awsui-components-react/polaris/text-filter";
import CollectionPreferences from "@amzn/awsui-components-react/polaris/collection-preferences";
import { getIssueTableConfig } from './IssueTableConfig';

export default function IssueTable(props) {
    const issueType = props.issueType || 'jira';
    const config = React.useMemo(() => getIssueTableConfig(issueType), [issueType]);
    
    const [filteringText, setFilteringText] = React.useState("");
    const [collectionPreferences, setCollectionPreferences] = React.useState({
        visibleContent: config.getDefaultVisibleContent(),
        wrapLines: true,
        custom: "table"
    });
    const [filteredIssues, setFilteredIssues] = React.useState([]);
    
    React.useEffect(() => {
        setFilteredIssues(props.issues);
    }, [props.issues]);

    const handleFilterChange = ({ detail }) => {
        const filter = detail.filteringText.toLowerCase().trim();

        if (!filter || filter.length === 0) {
            setFilteredIssues(props.issues);
        } else {
            const tmp = props.issues.filter(issue => {
                const matches = config.getFilterableFields(issue);
                return matches.some(field => field.includes(filter));
            });
            setFilteredIssues(tmp);
        }

        setFilteringText(filter);
    };

    return (
          <Table
            loading={props.loading}
            items={filteredIssues}
            columnDefinitions={config.getColumnDefinitions()}
            loadingText={`Loading ${config.getTypeName()}...`}
            trackBy='id'
            filter={
                <TextFilter
                  filteringPlaceholder={`Find ${config.getTypeName()}`}
                  filteringText={filteringText}
                  onChange={handleFilterChange}
                />
            }
            visibleColumns={collectionPreferences.visibleContent}
            empty={
              <div className="awsui-util-t-c">
                  <div className="awsui-util-pt-s awsui-util-mb-xs">
                      <b>No {config.getTypeName()}</b>
                  </div>
                  <p className="awsui-util-mb-s">
                      No {config.getTypeName()} filed for this job.
                  </p>
              </div>
            }
            preferences={
                <CollectionPreferences
                    title="Preferences"
                    confirmLabel="Confirm"
                    cancelLabel="Cancel"
                    onConfirm={({ detail }) => {setCollectionPreferences(detail)}}
                    preferences={collectionPreferences}
                    visibleContentPreference={{
                        title: "Select visible columns",
                        options: config.getVisibleContentOptions()
                    }}
                />
            }
          >
          </Table>
      );
}
